// extracted by mini-css-extract-plugin
export default {"editButton":"styles_editButton__6gphG"};